
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const STPPreventiveMachineryChecklistExportData = (props) => {
    const { ExcelData, name, date } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '48%' }}>

                <h5><span>&emsp;</span></h5>

                {/* <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4> */}
                {/* <h4 style={{ textAlign: 'center', fontSize: 16 }}>Navi Mumbai Muncipal Corporation</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>STP Maintenance Department</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>Project Name - {ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table[0].projectName : '-'}</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>Report Name - {name}</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>
                    Report Date - {date ? moment(date).format('DD-MM-YYYY') : '-'}
                </h4> */}

                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16 }}>Navi Mumbai Muncipal Corporation</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16 }}>STP Maintenance Department</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16 }}>
                        Project Name - {ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table[0].projectName : '-'}
                    </th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16 }}>Report Name - {name}</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16 }}>
                        Report Date - {date ? moment(date).format('DD-MM-YYYY') : '-'}
                    </th>
                </tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th>Reading Date </th>
                        <th>Mach Equipment Type </th>
                        <th>Machinery Details  </th>
                        <th style={{ borderRight: "1px solid black" }}>Status </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr style={{ width: '100%', border: "1px solid black" }}>
                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.machEquipmentType ? item.machEquipmentType : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.machineryDetails ? item.machineryDetails : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.actionName ? item.actionName : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div>
    )
}